import { render, staticRenderFns } from "./CreditNote.vue?vue&type=template&id=33736292&scoped=true&"
import script from "./CreditNote.vue?vue&type=script&lang=js&"
export * from "./CreditNote.vue?vue&type=script&lang=js&"
import style0 from "./CreditNote.vue?vue&type=style&index=0&id=33736292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33736292",
  null
  
)

export default component.exports